import { ENTITIES, MODULES, REPORTS } from '~/data/maquette'
import { canAccessModule } from '~/data/permissions'

/** Le tableau de bord est lui-même soumis à permission, pas seulement les modules métier. */
export const DASHBOARD_MODULE = 'tableauDeBord'

/** Le module ciblé par une route, quand elle en dépend clairement (liste/fiche/rapport/page de module ou de groupe). */
function moduleForPath(path: string): string | null {
  const p = path.split('/').filter(Boolean)
  if (p.length === 0) return DASHBOARD_MODULE
  if (p[0] === 'module' || p[0] === 'group') return p[1] ?? null
  if (p[0] === 'entity' && p[1]) return ENTITIES[p[1]]?.module ?? null
  if (p[0] === 'report' && p[1]) return REPORTS[p[1]]?.module ?? null
  return null
}

/** Première section de module accessible à l'utilisateur : repli quand le tableau de bord lui-même est refusé. */
function firstAccessibleModulePath(user: { modules: string[] }): string | null {
  const key = Object.keys(MODULES).find(k => canAccessModule(user, k))
  return key ? `/module/${key}` : null
}

export default defineNuxtRouteMiddleware(async (to) => {
  const user = useCurrentUser()
  if (!user.value) await fetchMe()

  if (to.path === '/login') {
    if (user.value) return navigateTo('/')
    return
  }

  if (!user.value) return navigateTo('/login')

  const moduleKey = moduleForPath(to.path)
  if (moduleKey && !canAccessModule(user.value, moduleKey)) {
    if (moduleKey === DASHBOARD_MODULE) {
      const fallback = firstAccessibleModulePath(user.value)
      if (fallback && fallback !== to.path) return navigateTo(fallback)
      return // aucun module accessible : on laisse passer plutôt que de bloquer complètement l'utilisateur
    }
    showToast('Ce rôle n\'a pas accès à ce module.')
    return navigateTo('/')
  }
})
